import { useRouter } from 'next/router';
import { useCallback } from 'react';
import * as Designs from '@pkg/entities/designs';
import * as Routes from '@pkg/utils/routes';
import { DesignLevel } from '@/lib/enums';
import useDesignStore from '../useDesignStore';

/**
 * @param {Object} revision
 * @param {String} revision.uuid
 * @param {Object} revision.design
 * @param {String} revision.design.uuid
 * @param {Object} level
 * @param {String} level.type
 * @param {String} level.uuid
 * @returns {Function}
 */
export default function useRestore(revision, level) {
  const onRestore = Designs.mutations.useRestore();
  const setFocus = useDesignStore((state) => state.setFocus);
  const router = useRouter();

  const designId = revision?.design.uuid;
  const revisionId = revision?.uuid;

  const handler = async (destination) => {
    const scoped = [
      DesignLevel.GROUP,
      DesignLevel.MANAGER,
      DesignLevel.ROLE,
    ].includes(level.type);
    await onRestore(
      designId,
      revisionId,
      undefined,
      scoped
        ? {
            source: { scope: level.type.toLowerCase(), entity_id: level.uuid },
            ...(destination ? { destination } : {}),
          }
        : {}
    );
    setFocus(level);
    Routes.pushDesignParts(router, { designId, revisionId: 'latest' });
  };

  return useCallback(handler, [
    designId,
    revisionId,
    level,
    onRestore,
    setFocus,
    router,
  ]);
}
